import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { PGET, DELETE, PUT } from "../../../api/adminApi";
import { CustomSvg } from "../../../utils/CustomSvg";
import { getDateTime } from "../../../utils/Dates";
import { toast } from "react-toastify";
import { Edit2, Trash2, Plus, Eye } from "react-feather";
import { Modal, Button } from "react-bootstrap";

export default function News() {
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(
      +localStorage.getItem("currentPageNews") || 0,
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  const paginate = (data) => {
    setCurrentPage(data.selected);
    localStorage.setItem("currentPageNews", data.selected);
  };

  const getItems = useCallback(async () => {
    // The API matches these parameters (page, size)
    const data = await PGET("/services/admin/api/news", true, {
      page: currentPage,
      size: 10,
    });
    setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
    setItems(data.data);
  }, [currentPage]);

  async function deleteItem(id) {
    if (window.confirm("Вы уверены, что хотите удалить эту новость?")) {
      const response = await DELETE(`/services/admin/api/news/${id}`);
      if (response?.success) {
        toast.success("Новость успешно удалена");
        getItems();
      }
    }
  }

  async function togglePublish(item) {
    const url = `/services/admin/api/news/${item.id}/${
        item.published ? "unpublish" : "publish"
    }`;
    const response = await PUT(url, {});
    if (response?.success) {
      toast.success(item.published ? "Новость скрыта" : "Новость опубликована");
      getItems();
    }
  }

  const handleShowModal = (item) => {
    setSelectedNews(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedNews(null);
  };

  useEffect(() => {
    getItems();
  }, [getItems]);

  return (
      <div
          className="br-5 card"
          style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
      >
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bold fs-3 mb-1">Новости</span>
          </h3>
          <div className="card-toolbar">
            <Link
                to="/admin/news/create"
                className="btn btn-sm btn-light-primary"
            >
              <Plus size={18} className="mr-1" />
              Добавить
            </Link>
          </div>
        </div>
        <div className="px-3 pb-4 pt-2">
          <div style={{ overflow: "auto", maxHeight: "75vh" }}>
            <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
              <thead className="position-sticky top-0 rounded">
              <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <th
                    style={{
                      width: "30px",
                      backgroundColor: "#E7372C",
                      fontWeight: "700",
                      borderTopLeftRadius: "8px",
                    }}
                    className="text-white text-center"
                >
                  №
                </th>
                <th
                    className="text-center text-white"
                    style={{ width: "60px", backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Фото
                </th>
                <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Заголовок
                </th>
                <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Текст
                </th>
                <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Дата создания
                </th>
                <th
                    className="text-start text-white"
                    style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Статус
                </th>
                <th
                    className="text-start text-white"
                    style={{
                      backgroundColor: "#E7372C",
                      fontWeight: "700",
                      borderTopRightRadius: "8px",
                    }}
                >
                  Действия
                </th>
              </tr>
              </thead>
              <tbody style={{ overflowX: "auto" }}>
              {items.map((item, index) => {
                return (
                    <tr key={item.id} className="borderBottom align-middle">
                      <td className="text-center">
                        {currentPage === 0
                            ? index + 1
                            : currentPage * 10 + index + 1}
                      </td>
                      <td className="text-center">
                        {item.thumbPhoto ? (
                            <img
                                src={
                                  item.thumbPhoto.startsWith("http")
                                      ? item.thumbPhoto
                                      : "https://bo.akfacomfort.uz" + item.thumbPhoto
                                }
                                alt={item.title || "thumbnail"}
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                  border: "1px solid #ddd"
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  backgroundColor: "#f3f6f9",
                                  borderRadius: "6px",
                                  display: "inline-block"
                                }}
                            ></div>
                        )}
                      </td>
                      <td className="text-start">{item.title}</td>
                      <td
                          className="text-start"
                          style={{
                            maxWidth: "300px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                      >
                        {item.text}
                      </td>
                      <td className="text-start">
                        {getDateTime(item.createdTime)}
                      </td>
                      <td className="text-start">
                        <div
                            onClick={() => togglePublish(item)}
                            className="cursor-pointer d-flex align-items-center"
                        >
                          {item.published ? (
                              <div className="badge bg-success">Опубликован</div>
                          ) : (
                              <div className="badge bg-danger">Скрыт</div>
                          )}
                        </div>
                      </td>
                      <td className="text-start">
                        <div className="d-flex justify-content-start">
                          <button
                              onClick={() => handleShowModal(item)}
                              className="btn btn-icon shadow-sm btn-active-color-primary btn-sm me-2"
                              title="Просмотреть"
                          >
                            <Eye size={18} />
                          </button>
                          <Link
                              to={`/admin/news/update/${item.id}`}
                              className="btn btn-icon shadow-sm btn-active-color-primary btn-sm me-2"
                              title="Редактировать"
                          >
                            <Edit2 size={18} />
                          </Link>
                          <button
                              onClick={() => deleteItem(item.id)}
                              className="btn btn-icon shadow-sm btn-active-color-primary btn-sm"
                              title="Удалить"
                          >
                            <Trash2 size={18} color="red" />
                          </button>
                        </div>
                      </td>
                    </tr>
                );
              })}
              </tbody>
            </table>
          </div>
          {pageCount > 1 && (
              <ReactPaginate
                  forcePage={currentPage}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={pageCount}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={1}
                  onPageChange={paginate}
                  containerClassName={"pagination"}
                  activeClassName={"bg-dark text-white"}
                  pageClassName={"page-item box-shadow br-5"}
              />
          )}
        </div>

        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedNews ? selectedNews.title : "Детали новости"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedNews && (
                <div>
                  <div className="mb-3">
                    <strong>Дата создания:</strong>{" "}
                    {getDateTime(selectedNews.createdTime)}
                  </div>
                  {selectedNews.photo && (
                      <div className="mb-4 text-center">
                        <img
                            src={
                              selectedNews.photo.startsWith("http")
                                  ? selectedNews.photo
                                  : "https://bo.akfacomfort.uz" + selectedNews.photo
                            }
                            alt={selectedNews.title}
                            style={{ maxWidth: "100%", maxHeight: "400px" }}
                            className="img-fluid rounded"
                        />
                      </div>
                  )}
                  {selectedNews.photo && (
                      <div className="separator my-4 opacity-50"></div>
                  )}
                  <div
                      className="text-gray-800"
                      style={{
                        whiteSpace: "pre-wrap",
                        lineHeight: "1.8",
                        fontSize: "15px",
                        fontWeight: "400",
                      }}
                  >
                    {selectedNews.text}
                  </div>
                </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Закрыть
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
  );
}